import { BrowserRouter } from "react-router-dom";

import AppShell from "./app/AppShell";

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
